// required just for webpack bundling
import '../styles/index.scss'
/* eslint-disable import/first */
require('es6-promise').polyfill()
// also polyfills, i.e. writes to global window.Fetch (if needed)
import 'whatwg-fetch'

import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, compose } from 'redux'
import { responsiveStoreEnhancer } from 'redux-responsive'

import { trackException } from './utils/tracking'
import { reActivateOptimizely } from './utils/optimizely'

import Root from './react/containers/Root'
import rootReducer from './reducers'
import { setMxd } from './reducers/analytics'

import { IS_PROD, IS_WEB } from './config/'
/* eslint-enable */

const mixpanelDistinctId =
  IS_WEB && (window.location.search.match(/[?&]mxd=([^&]*)/) || [])[1]

window.addEventListener('error', e => {
  trackException(e)
})

function domReady () {
  return new Promise(function (resolve) {
    var state = document.readyState
    if (
      state === 'complete' ||
      state === 'loaded' ||
      // can fire too early in IE, before the whole html is parsed..
      (state === 'interactive' && !!window.__INITIAL_STATE__)
    ) {
      return resolve()
    }

    document.addEventListener('DOMContentLoaded', function () {
      resolve()
    })
  })
}

if (
  IS_WEB &&
  mixpanelDistinctId &&
  window.mixpanel &&
  window.mixpanel.sdk &&
  window.mixpanel.sdk.identify
) {
  // use mixpanelDistinctId, passed along from another snips site,
  // so we can continue to track as the same user.
  // This is for the SDK funnel; in order to not mess with mixpanel stats
  // for the snips (get-snips-ai) project, we use a separate mixpanel instance here (sdk).
  window.mixpanel.sdk.identify(mixpanelDistinctId)
}

domReady().then(() => {
  const hydratedState = window.__INITIAL_STATE__
  let storeEnhancer = responsiveStoreEnhancer
  if (window.devToolsExtension) {
    storeEnhancer = compose(
      responsiveStoreEnhancer,
      window.devToolsExtension()
    )
  }

  const store = createStore(rootReducer, hydratedState, storeEnhancer)
  // pass the mixpanel distinct id along (read from reducer by f.e. Link)
  // since we have two projects, check first if the sdk specific one exists,
  // otherwise fallback do default project for this site
  if (
    window.mixpanel &&
    window.mixpanel.sdk &&
    window.mixpanel.sdk.get_distinct_id
  ) {
    store.dispatch(setMxd(window.mixpanel.sdk.get_distinct_id()))
  } else if (window.mixpanel && window.mixpanel.get_distinct_id) {
    // otherwise, pass along the mixpanel id used here (that is also used for the snips mixpanel project)
    store.dispatch(setMxd(window.mixpanel.get_distinct_id()))
  }

  const reactDivElement = document.getElementById('react_div')
  if (!reactDivElement) {
    return
  }
  const reactDOMFunction = IS_PROD ? ReactDOM.hydrate : ReactDOM.render
  reactDOMFunction(
    <Root store={store} />,
    reactDivElement,
    reActivateOptimizely
  )
})
